import React, { useEffect, useState } from 'react'
import styles from './modal.module.css'
import { Button, IconButton, Box, TextField } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import icon_delete from '../../assets/icons/e-learning/delete.svg'
import * as api from '../../pages/services/api'
import Loader from '../Loader';

export default function ModalAddCategory({ onClose, onSubmit }) {

  const [loading, setLoading] = useState(false)
  const [group, setGroup] = useState('')

  const clickNewgroup = () => {
    console.log(group)
    newCourseGroup()
  }

  const newCourseGroup = async () => {
    setLoading(true)
    let res = await api.newCourseGroup(group)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        onClose()
        onSubmit()
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  return (
    <>
      <Loader loading={loading} />
      <Box className={styles.backgroundModal}>
        <Box className={styles.boxModal}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gridGap: '10px' }}>
              <Box sx={{ border: '5px solid #478F96' }} />
              <Box sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#478F96',
                "@media (max-width: 800px)": {
                  fontSize: '16px',
                }
              }}>เพิ่มหมวดหมู่</Box>
            </Box>
            <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
              <IconButton onClick={() => { onClose() }}>
                <ClearIcon />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ display: 'grid', gridGap: '20px' }}>
            <Box>
              <Box>ชื่อหมวดหมู่</Box>
              <TextField
                placeholder='ทักษะการสื่อสาร'
                size="small"
                fullWidth
                value={group}
                onChange={(e) => { setGroup(e.target.value) }}
              />
            </Box>
            <Button
              variant='contained'
              onClick={() => {
                clickNewgroup()
              }}
            >เพิ่มหมวดหมู่</Button>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export function ModalEditCategory({ onClose, onSubmit, data }) {
  const [loading, setLoading] = useState(false)
  const [nameGroup, setNameGroup] = useState('')

  useEffect(() => {
    // console.log(data)
    setNameGroup(data['e_learning_group_name'])
  }, [])

  const clickUpdategroup = () => {
    let inform = {
      "e_learning_group_code": data['e_learning_group_code'],
      "e_learning_group_name": nameGroup,
      "remark": null,
      "doc_status": data['doc_status'],
      "created_date": data['created_date'],
      "created_user": data['created_user'],
      "updated_date": null,
      "updated_user": null
    }
    // console.log(inform)
    updateCourseGroup(inform)
  }

  const clickDeletegroup = () => {
    let code = data['e_learning_group_code']
    // console.log(code)
    deleteCourseGroup(code)
  }

  const updateCourseGroup = async (inform) => {
    setLoading(true)
    let res = await api.updateCourseGroup(inform)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        onClose()
        onSubmit()
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }

  const deleteCourseGroup = async (id) => {
    setLoading(true)
    let res = await api.deleteCourseGroup(id)
    setLoading(false)
    if (res) {
      if (res['data']['code'] === 200) {
        onClose()
        onSubmit()
      } else {
        //alert(res['data']['message'])
      }
    } else {
      alert('ไม่ตอบสนอง')
    }
  }



  return (
    <>
      <Loader loading={loading} />
      <Box className={styles.backgroundModal}>
        <Box className={styles.boxModal}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gridGap: '10px' }}>
              <Box sx={{ border: '5px solid #478F96' }} />
              <Box sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#478F96',
                "@media (max-width: 800px)": {
                  fontSize: '16px',
                }
              }}>แก้ไขหมวดหมู่</Box>
            </Box>
            <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
              <IconButton onClick={() => { onClose() }}>
                <ClearIcon />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ display: 'grid', gridGap: '20px' }}>
            <Box>
              <Box>ชื่อหมวดหมู่</Box>
              <TextField
                placeholder='ทักษะการสื่อสาร'
                size="small"
                fullWidth
                value={nameGroup}
                onChange={(e) => { setNameGroup(e.target.value) }}
              />
            </Box>

            <Button
              variant='contained'
              onClick={() => {
                clickUpdategroup()
              }}
            >แก้ไขชื่อหมวดหมู่</Button>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Box sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center'
              }}
                onClick={() => { clickDeletegroup() }}
              >
                <img src={icon_delete} />
                <Box sx={{ color: '#F77575' }}>ลบหมวดหมู่</Box>
              </Box>
            </Box>

          </Box>
        </Box>
      </Box>
    </>
  )
}
